import { Api_Url } from "../utils/ApiUrl";
import Environment from "../utils/Environment";
export const getMergedProjectsConfig = async (PROJECTS_CONFIG) => {
    try {
        const response = await fetch(
            `${Api_Url}/pro-projects/minimal/list`
        );

        const result = await response.json();

        if (!result?.data) return PROJECTS_CONFIG;

        // Transform API data to match your new structure
        const apiProjects = result?.data?.map((project) => ({
            id: project?.projectTicker,
            name: project?.projectName?.toUpperCase(),
            shortName: project?.projectTicker,
            imageSrc: project?.projectImage,
            contracts: {
                preSale: project.preSaleContract,
                claim: project.claimContract,
            },
            graph: {
                url: Environment?.automationGraph,
                queryType: "standard",
            },
                // API does not provide graph
            contractType: "screx", // default (change if needed)
            refLink: `https://buy.gems.vip/${project?.projectTicker}?leader=`, // API doesn't provide
            enabled: true,
            ...project, // Spread any additional properties from API if needed
            automation:true,
        }));

        // Remove duplicates (if same id exists, API overrides)
        const mergedMap = new Map();
        // Then override/add API ones
        // apiProjects.forEach((project) => {
        //     mergedMap.set(project.id.toUpperCase(), project);
        // });
        // First add static
        PROJECTS_CONFIG.forEach((project) => {
            mergedMap.set(project.id.toUpperCase(), project);
        });

        

        return Array.from(mergedMap.values());
    } catch (error) {
        console.error("Error fetching projects:", error);
        return PROJECTS_CONFIG; // fallback
    }
};
